import { render } from "./Service.vue?vue&type=template&id=56caab85&scoped=true"
const script = {}

import "./Service.vue?vue&type=style&index=0&id=56caab85&scoped=true&lang=css"

import exportComponent from "/home/runner/work/motokandemir-web/motokandemir-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56caab85"]])

export default __exports__